import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'closerContactPhone',
    label: 'Contact Phone',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'closerContactEmail',
    label: 'Contact Email',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'closerName',
    label: 'Closer Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'closerLicenseNumber',
    label: 'License Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const closerInformationForm = {
  name: FormNames.CLOSING_COMPANY_INFORMATION,
  label: 'Closer Information',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
